export const getSeoState = (state) => state.seo;
export const getSeoDefaultLoadedState = (state) => state.seo.defaultLoaded;
export const getSeoContentLoadedState = (state) => state.seo.contentLoaded;

export const getSeoPageParamsState = (state) => state.seo.pageParams;
export const getSeoDefaultDataState = (state) => state.seo.defaultData;
export const getSeoDataState = (state) => state.seo.data;
